import { Button, Typography } from '@mui/material';
import React from 'react';
import styles from './RoamingBanner.module.scss';
import useRoamingBanner from './useRoamingBanner';

const RoamingBanner = ({ roamingBannerData }) => {
  const { formattedTitle, description, buttonText, redirectUrl, imageSrc } = useRoamingBanner(roamingBannerData);

  if (!roamingBannerData) {
    return null;
  }

  return (
    <section className={styles.container}>
      <div className={styles.banner}>
        <div className="row g-0">
          <div className="col-12 col-lg-6">
            <div className="h-100 w-100">
              <img src={imageSrc} alt="" className="h-100 w-100 object-fit-cover" />
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="h-100 d-flex flex-column justify-content-between gap-4 p-4 gap-md-5 py-xl-5">
              <div className="d-flex flex-column gap-2 gap-lg-3">
                <Typography content="div" variant="h4" color="black" style={{ whiteSpace: 'pre-wrap' }}>
                  {formattedTitle.join('\n')}
                </Typography>
                <Typography content="div" variant="body1" color="black">
                  {description}
                </Typography>
              </div>
              <Button
                disableRipple
                disableFocusRipple
                disableTouchRipple
                disableElevation
                type="button"
                variant="contained"
                className="rounded-5 px-4 py-2 me-md-auto"
                sx={{
                  ':focus': { outline: 'none' },
                  ':focus-visible': { outline: '2px solid black', outlineOffset: '3px' },
                }}
                href={redirectUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {buttonText}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RoamingBanner;
